import { render, staticRenderFns } from "./AdminUserEditPage.vue?vue&type=template&id=59591a8c"
import script from "./AdminUserEditPage.vue?vue&type=script&lang=js"
export * from "./AdminUserEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports